export default "__VITE_ASSET__hrEdQeVG__"